import React from "react";
import Link from "@qlik/qlik/src/components/Link";
import scrollTo from "gatsby-plugin-smoothscroll";
import { getSpacingClassName } from "@qlik/qlik/src/lib/util/spacing";
import { getCardBodyContent } from "@qlik/qlik/src/lib/util/helpers";
import * as styles from "./styles.module.css";

/**
 * TableOfContent component.
 * Renders a table of content with title, body and cta.
 * @param {Object} data - The component props.
 */
const TableOfContent = ({ data }) => {
    const { cardItem, additionalConfiguration, customId } = data || {};
    const { title, cta } = cardItem || {};

    const bodyContent = getCardBodyContent(cardItem);
    const sectionSpacingClassName = getSpacingClassName(additionalConfiguration);

    // Render the TableOfContent component
    return (
        <section className={` ${sectionSpacingClassName} overflow-hidden toc-intro ${styles.tocIntro}`} id={customId}>
            <div className="container">
                <div className={`grid gap-x-7.5 relative ${styles.gridRow}`}>
                    <div className="toc">
                        <div className="pr-0 pl-5 lg:px-5 lg:pt-10 pb-15.5 lg:py-10">
                            <h2 className="tag-2 mb-7.5 text-blue tracking-wide4">{title}</h2>
                            <div className="grid gap-[33px] py-5 border-t border-gray/30">
                                {cta?.map((link) => (
                                    <Link
                                        key={link.id}
                                        className="grey-link text-sm"
                                        to={link.externalUrl}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            scrollTo(link.externalUrl);
                                        }}
                                    >
                                        {link.text}
                                    </Link>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="-mx-10 md:mx-0 px-10 py-15 md:pt-7.5 md:pb-11.25 lg:py-10 pr-7.5 lg:pr-0 bg-stone-light">
                        {bodyContent && <div className={`${styles.richTextWrapper}`}>{bodyContent}</div>}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default TableOfContent;
